<template>
    <div class="px-6">
        <v-divider v-if="$vuetify.breakpoint.xs"></v-divider>

        <div class="container px-0">
            <div class="button-detalhes__container">
                <span class="label-detalhes__text">{{ quantidadeCotas > 1 ? 'Ao acessar o "Detalhes da venda", você encontrará os processos separados por proposta e as ações disponíveis!' : 'Ao acessar "Detalhes da venda", você encontrará mais ações disponíveis!' }}</span>
                <button @click="acaoReservar" class="button-detalhes mt-2">
                    <v-icon left size="16" color="white" class="mr-3">
                        mdi-file-document
                    </v-icon>
                    <span class="button-text">DETALHES DA VENDA</span>
                </button>
                <v-tooltip v-if="temReserva && mostrarExpiracaoPorStatusPedido" bottom max-width="250px" color="white">
                    <template v-slot:activator="{ on, attrs }">
                        <button
                                @click="acaoExpiracaoReservas"
                                class="button-detalhes mt-2"
                                v-bind="attrs"
                                v-on="on"
                        >
                            <v-icon left size="16" color="white" class="mr-3">
                                mdi-clock-outline
                            </v-icon>
                            <span class="button-text">EXPIRAÇÃO DAS RESERVAS</span>
                        </button>
                    </template>
                    <span style="color: black;">Ao clicar nesse botão, você visualizará as cotas reservadas e a data de expiração delas.</span>
                </v-tooltip>
            </div>
        </div>

        <expiracao-reservas-modal
                v-model="showExpiracaoModal"
                :reservas="reservasExpiracao"
        />
    </div>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import ExpiracaoReservasModal from './ExpiracaoReservasModal.vue'
  import { AlertTypes } from '@/plugins/alerts_types'
  import { StatusPedido } from '@/plugins/constants'

  export default {
    name: 'ActionColumn',
    components: {
      ExpiracaoReservasModal
    },
    props: {
      quantidadeCotas: {
        type: Number,
        required: false
      },
      carrinho: {
        type: Object,
        required: false,
        default: null
      }
    },
    data () {
      return {
        showExpiracaoModal: false,
        reservasExpiracao: []
      }
    },
    computed: {
      temReserva () {
        if (!this.carrinho || !this.carrinho.pedidos || !this.carrinho.pedidos.length) {
          return false
        }
        return this.carrinho.pedidos.some(pedido => pedido.id_reserva)
      },
      mostrarExpiracaoPorStatusPedido () {
        if (!this.carrinho.pedidos || !this.carrinho.pedidos.length || this.carrinho.pedidos.length <= 0) {
          return false
        }
        return (this.carrinho.pedidos[0].status_pedido === StatusPedido.Rascunho)
      }
    },
    methods: {
      acaoReservar () {
        this.$emit('acaoDetalhes')
      },
      async acaoExpiracaoReservas () {
        try {
          const response = await this.$http.get(`/carrinho/reservas-expiracao`, {
            params: {
              id_carrinho: this.carrinho.id_carrinho
            }
          })
          this.reservasExpiracao = response.data
          this.showExpiracaoModal = true
        } catch (error) {
          console.error(error)
          notification(AlertTypes.ERROR, 'Erro ao carregar os dados de expiração das reservas.')
        }
      }
    }
  }
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 240px;
    height: 100%;
}

.label-detalhes__text {
    font-size: 1.02rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 245px;
    box-sizing: border-box;
    text-align: center;
}

.button-detalhes__container {
    width: 100%;
    max-width: 300px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
}

.button-detalhes {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    border-radius: 8px;
    font-size: 1.1rem;
    background-color: var(--primary);
    color: white;
    padding: 12px 16px;
    border: none;
    cursor: pointer;
    text-align: center;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    transition: background-color 0.3s, opacity 0.3s;
    position: relative;
    overflow: hidden;
    white-space: normal;
    min-height: 48px;
}

.button-text {
    display: inline-block;
    word-wrap: break-word;
    white-space: normal;
    line-height: 1.2;
}

.button-detalhes::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--gray);
    opacity: 0;
    transition: opacity 0.3s;
}

.button-detalhes:hover::after {
    opacity: 0.1;
}

.button-detalhes i {
    margin-right: 8px;
    z-index: 1;
    flex-shrink: 0;
}

.button-detalhes span {
    z-index: 1;
}
</style>
